import { createRoute } from "@tanstack/react-router";

import { teamRoute } from "../../platform/routes";
import { AppearanceScreen } from "./AppearanceScreen";

/** The Account page's Appearance tab: the theme families (spec web/appearance-tab). */
export const appearanceRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "account/appearance",
  component: AppearanceScreen,
});
